export const CHANGE_INPUT = 'containers/LoginContact/CHANGE_INPUT';
export const SUBMIT_FORM = 'containers/LoginContact/SUBMIT_FORM';
export const FORM_SUBMITTED_SUCCESS = 'containers/LoginContact/FORM_SUBMITTED_SUCCESS';
export const FORM_SUBMITTED_FAIL = 'containers/LoginContact/FORM_SUBMITTED_FAIL';
export const ERROR = 'containers/LoginContact/ERROR';
export const RESET = 'containers/LoginContact/RESET';
